import { TagModels } from '../enums';

export interface ITagInputDto {
    id?: string;
    name: string;
    color?: string;
    model: TagModels;
}
